module.exports = __webpack_public_path__ + "img/weixin.e24d2a29.svg";